import React from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-light-svg-icons/faCheck';
import { TypedMemo } from '../../../common/types';
import { addSongFlowMessages } from './addSongFlowMessages';
import { BioLinkTick } from './useBioLinkTick';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole page; each part uses its own slice of it */
import styles from './CatalogAddSong.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface BioLinkTickRowProps {
  tick: BioLinkTick;
  disabled?: boolean;
}

/**
 * The tick "Auto add to my Bio Link" (design smartlink-editor e1, e5) under the Artist field of step 1
 * and on the confirm step of a released song. The small page picture goes away on a phone.
 */
const BioLinkTickRowComponent: React.FC<BioLinkTickRowProps> = ({ tick, disabled = false }) => {
  const intl = useIntl();
  if (!tick.isShown) {
    return null;
  }
  let body = intl.formatMessage(addSongFlowMessages.bioTickOn);
  if (!tick.isOn) {
    body = intl.formatMessage(
      tick.isOffBySetting ? addSongFlowMessages.bioTickOffBySetting : addSongFlowMessages.bioTickOffByHand
    );
  }
  return (
    <label
      htmlFor="add-song-bio-tick"
      className={clsx(styles.bioTick, tick.isOn && styles.bioTickOn)}
      data-testid="add-song-bio-tick"
    >
      <input
        id="add-song-bio-tick"
        type="checkbox"
        className={styles.bioTickInput}
        checked={tick.isOn}
        disabled={disabled}
        onChange={(event) => tick.setOn(event.target.checked)}
      />
      <span className={clsx(styles.bioTickBox, tick.isOn && styles.bioTickBoxOn)} aria-hidden>
        {tick.isOn && <FontAwesomeIcon icon={faCheck} />}
      </span>
      <span className={styles.grow}>
        <b>{intl.formatMessage(addSongFlowMessages.bioTick)}</b>
        <small>{body}</small>
      </span>
      <span className={styles.bioTickPage} aria-hidden>
        <i className={styles.bioTickAvatar} />
        <i className={clsx(styles.bioTickLine, tick.isOn && styles.bioTickLineNew)} />
        <i className={styles.bioTickLine} />
        <i className={styles.bioTickLine} />
      </span>
    </label>
  );
};

export const BioLinkTickRow = TypedMemo(BioLinkTickRowComponent);
